// 工事件名で工事検索

export const SearchConstruction = (allData: any, searchKeyword: string) => {
  if (!allData || !Array.isArray(allData)) {
    return [];
  }

  const filteredData = allData.filter(item =>
    item.name.includes(searchKeyword)
  );

  return filteredData;
};
